import store from "../../../../core/store";

export const listCompanies = () => {
	return store.dispatch({
		action: "table.superadmin_companies/LIST_COMPANIES",
		method: "GET",
		endpoint: "/superadmin/companies",
		main: true
	});
};